// Filters
function Loader(isShow) {
  if (isShow) {
  }
  else {
  }
}
//graphgl

const endpoint = 'https://www.nodoubtshoes.com/api/2020-10/graphql.json';
const gl_token='ee60d86e3300569ecad5364a1f8b1bd9';
var productFilters={};
var appliedFilter={};
var filteredProducts=[];
var lastFilter;
var pageInx=1;
var productCards;
const perpage=32;

  
function loader(isShow) {
  if (isShow) {
    $('.loader').show();
  }
  else {
    $('.loader').hide();
  }
}
function FetchData(query,callback) {
  
  fetch(endpoint, 	{
	'async': true,
	'crossDomain': true,
	'method': 'POST',
	'headers': {
		'X-Shopify-Storefront-Access-Token': gl_token,
		'Content-Type': 'application/graphql',
	},
    body:  query
  }).then(res => res.json())
	.then(data => {
		callback(data)
	});

}

function FetchDataWithVariables(queryData, variablesData, callback) {

  fetch(endpoint, {
    'async': true,
    'crossDomain': true,
    'method': 'POST',
    'headers': {
      'X-Shopify-Storefront-Access-Token': gl_token,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ query: queryData, variables: variablesData })
  }).then(res => res.json())
    .then(data => {
      callback(data)
    });

}

var productsForFilter;

function getCollectionData(callback) {
	FetchData(`query {
collectionByHandle(handle: "${collectionHandle}") {
      products( first: 250) {
        edges{
		  cursor
          node {
            id
            metafields (first: 20){
              edges{
                node{
				  value
				  key
              }
            }
          }
        }
      }  
    }
  }
}`,function(_data) {
	productsForFilter=[];
	const Products = _data.data.collectionByHandle.products.edges;
	for(let p of Products) {
		var _product={
					id:p.node.id
				};
		for(let mf of p.node.metafields.edges) {
			_product[mf.node.key]=mf.node.value;
		}
		productsForFilter.push(_product);
	}
	callback.apply();
});
}
  
function getAllDataGQL(callback) {
	FetchData(`query {
	shop {
      products( first: 250) {
        edges{
		  cursor
          node {
            id
            metafields (first: 20){
              edges{
                node{
				  value
				  key
              }
            }
          }
        }
      }  
    }
  }
}`,function(_data) {
	productsForFilter=[];
	const Products = _data.data.shop.products.edges;
	for(let p of Products) {
		var _product={
					id:p.node.id
				};
		for(let mf of p.node.metafields.edges) {
			_product[mf.node.key]=mf.node.value;
		}
		productsForFilter.push(_product);
	}
	callback.apply();
});
}


var _sortProducts=[];
  
function getCollectionDataSort(sort,isRevert,callback) {
  var _query;
  if (collectionHandle=='all') {
     _query=`query {
shop {
      products( first: 250,sortKey:${sort}) {
        edges{
          node {
            id
            
        }
      }  
    }
  }
}
`
  }
  else {
    _query=`query {
collectionByHandle(handle: "${collectionHandle}") {
products( first: 250,sortKey:${sort}) {
        edges{		  
          node {
            id            
          }
        }
      }  
    }
  }
`
  }
	FetchData(_query,function(_data) {
    var _products;
    _sortProducts=[];
    if (collectionHandle=='all') {
      _products=_data.data.shop.products.edges;
    }
    else {
      _products=_data.data.collectionByHandle.products.edges;
    }
    for(let p of _products) {
		_sortProducts.push( p.node.id);				
	}
    if (isRevert) {
      _sortProducts=_sortProducts.reverse()
    }
	showProducts();
    if ($(window).width()>599) {          
       $('.filter-sort__title').next().removeClass('filter-sort__list--active');
       $('.filter-sort__title').next().slideUp(150);
       $('.filter-sort__title').removeClass('filter-sort__title--active');
    }
    else {
       $('.filter-sort__list').removeClass('filter-sort__list--active');
       $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
       $('html').removeClass('no-scroll');
    }
});
}
function getAllData(callback,page) {

  
   
   $.ajax({
        method    : 'GET',
        url       : document.location.origin+document.location.pathname+"/?view=json"+(page!=undefined?"&page="+page:""),        
        success: function (data) {
          var _d=data.replace(/\n/g,'').replace(/,}/g,'}').replace(/,]/g,']');   
          
          
          if (_d.replace(/ /g,'')!="") {
            var _data=JSON.parse(_d).products;
          	for(let p of _data) {
            var _product={};
            for (const [k, v] of Object.entries(p)) {
              	if (k=='id') {                
              		_product[k]=window.btoa('gid://shopify/Product/'+v);
              	}
              	else {
                	_product[k]=v;
              	}
            	}
				productsForFilter.push(_product);
		    }
            //if (_data.length==50) {
              getAllData(callback,page!=undefined?page+1:2);
            //}
           // else {
            //  callback.apply();
            //}
          }
          else {
            callback.apply();
          }
		  
        }
   });
}
function getDataProducts(ids) {
	FetchData(`query {
		nodes(ids: ${JSON.stringify(ids)}) {
		...on Product {
			id
			title
			handle
			variants(first:10) {
      			edges
      			{
        	   		node {
          				compareAtPrice
          				price
          				availableForSale
          				sku		
						quantityAvailable
        			}
      			}
    		}
            images(first: 1) {
              edges {
                node {
                  originalSrc
                  altText
                }
              }
            }
		}
	}
	}`,function(_data) {
console.log(_data);
});
}

  
  function getMetaProducts(ids,data,callback) {
	FetchData(`query {
		nodes(ids: ${JSON.stringify(ids)}) {
		...on Product {
			id
            metafields (first: 20){
              edges{
                node{
				  value
				  key
              }
            }
		}
	}
}}`,function(_data) {
      _data.data.nodes.forEach(x=> {
        var _id=window.atob(x.id).replace('gid://shopify/Product/','');
        var _availableArray=x.metafields.edges.filter(c=>c.node.key=='preorder_date_available');
        if (_availableArray.length>0) {
          data.items.forEach(y=> {
            if (y.product_id==_id) {
              y.available=_availableArray[0].node.value;
            }
          });
          
        }
      });
      callback.apply(data);
});
}


function buildUI() {
  productFilter={};
    $('[data-filter]').each(function() {
    var _filterName=$(this).data('filter');
    var _filterList={};
    for(let p of productsForFilter) {
      if (p[_filterName]!=undefined) {
        var _fData=p[_filterName]+'';
        if (_fData.indexOf('|')!=-1) {
          _fData.split('|').forEach(_fDataS => _filterList[_fDataS]=_filterList[_fDataS]!=undefined?(_filterList[_fDataS]+1):1);          
        }
        else {
          _filterList[_fData]=_filterList[_fData]!=undefined?(_filterList[_fData]+1):1;
        }
        
      }
    }
    if (Object.keys(_filterList).length==0) {
      	$(this).remove();
    }
    else {
      var _fEl=$(this).find('.filter__list');
      _fEl.empty();
      for (const [k, v] of Object.entries(_filterList)) {
        _fEl.append(`<div class="filter__item" data-filter-value="${k}">${k}<span class="filter__count">(${v})</span></div>`);
      }
    }
    productFilters[_filterName]=_filterList;
  }); 
  //link filter events
  $('[data-filter] .filter__item').click(function() {
    applyFilter(this);
  });
  
  if (productsForFilter.length>perpage) {
     $('[data-container="loadmore"]').show();
     $('[data-container="loadmore-summary"]').text("You've viewed " + perpage + " of " + productsForFilter.length + " products");
    $('[data-container="loadmore-percentage"] span').css('width',parseInt(100*perpage/productsForFilter.length)+'%');
  }
  else {
     $('[data-container="loadmore"]').hide();
  }
  var _st;
  var _page;
  $.each(document.location.search.substring(1).split('&'), function () {
       if (this.split('=')[0] == 'page_m') _page=this.split('=')[1];
       if (this.split('=')[0] == 'scrollto') _st = this.split('=')[1];                	
  });
  if (_page!=undefined) {
       pageInx=parseInt(_page);
       showProducts(false, function () {
         if (_st != undefined && this==_st) {
           $('html, body').scrollTop($('[data-product="' + _st + '"]').offset().top);
         }
       });
  }
}


  
function applyFilter(el) {
    var _filter=$(el).closest('[data-filter]').data('filter');
    var _filterValue=$(el).data('filter-value');
    if (appliedFilter[_filter]!=undefined && appliedFilter[_filter].includes(_filterValue)) {
      appliedFilter[_filter]=appliedFilter[_filter].filter(item => item !== _filterValue);  
      $(el).removeClass('filter__item--active');
      $(`[data-filter-apply='${_filter}|${_filterValue}']`).remove();
      if ($(window).width() < 600) {
        $('html,body').scrollTop(0);
      }
      showProducts(true);
    }
    else {
      appliedFilter[_filter]=appliedFilter[_filter] || [];
      appliedFilter[_filter].push(_filterValue);
      lastFilter=_filter;
      $(el).addClass('filter__item--active');
        if ($(window).width() < 600) {
         $('html,body').scrollTop(0);
      	}
       	showProducts();
    }
    //now find all products for this filters
   
  
  
  	$("[data-filter-apply]").off('click').on('click',function() {
       var _f=$(this).data('filter-apply').split('|');
       appliedFilter[_f[0]]=appliedFilter[_f[0]].filter(item => item !== _f[1]);  
       $(`[data-filter="${_f[0]}"] [data-filter-value="${_f[1]}"]`).removeClass('filter__item--active');
       $(this).remove();
       showProducts(true);
  	});
	pageInx=1;
    $.each(document.location.search.substring(1).split('&'), function () {
     if (this.split('=')[0] == 'page_m') {
       const obj = { Page: document.location.pathname, Url:"?page_m=1" };            
       history.pushState(obj, obj.Page, obj.Url);
     }
    });
  	

}
  function showProducts(removeFilter,callback) {
    

    $('[data-filter]').removeClass('filter__group--selected');
    $('.filter__title').removeClass('filter__title--selected');
    $('.filter-refine__title').removeClass('filter-refine__title--selected');
    for (const [k, v] of Object.entries(appliedFilter)) {
      if (v.length>0) {
      	$(`[data-filter="${k}"]`).addClass('filter__group--selected');
      	$(`[data-filter="${k}"] .filter__title`).addClass('filter__title--selected');
        $('.filter-refine__title').addClass('filter-refine__title--selected');
      }
      v.forEach(_v=> {        
        if ($(`[data-filter-apply='${k}|${_v}']`).length==0) {
          $('[data-action="clearfilter"]').before(`<div class='filter-tags__tag' data-filter-apply='${k}|${_v}'>${_v}<i class='fa fal-times'></i></div>`);
        }
      });
    }
    
    filteredProducts=[];
  	productsForFilter.forEach(p=> {
       var isFound=true;
       for (const [k, v] of Object.entries(appliedFilter)) {
         if (v.length>0) {
            if (p[k]!=undefined &&  p[k].indexOf('|')!=-1) {
              
                 if (v.filter(item =>   p[k].split('|').filter(item1=>item1==item).length>0).length==0) {
           				isFound=false;
                   break;
                 };          
              
        	}
            else if (v.filter(item => item === p[k]).length==0) {
           		isFound=false;
           		break;
         	}
         }
       }
       if (isFound) {
         filteredProducts.push(p.id);	
       }
  	});

  
    //show/hide available filters
    const _productsWithFilter=productsForFilter.filter(x=>filteredProducts.includes(x.id));
    $('[data-filter]').each(function() {
      	const fEl=this;
        const f=$(this).data('filter');
        const fv=_productsWithFilter.filter(p=>p[f]!=undefined);
        $('[data-filter-value]',this).each(function() {
          const _v=$(this).data('filter-value');
          var p_count=fv.filter(p=> p[f].split('|').filter(item1=>item1==_v).length>0).length;           
          
          if (p_count==0) {
             if (f!=lastFilter ) {
            	$(this).addClass('filter__item--disabled');
                $(this).find('.filter__count').text('('+p_count+')');
             }
          }
          else {
            if (f!=lastFilter || $(this).hasClass('filter__item--disabled')) {
            	$(this).removeClass('filter__item--disabled');
            	$(this).find('.filter__count').text('('+p_count+')');
            }
          }
        });
      
    });
    if ($("[data-filter-apply]").length>0) {
    	$('[data-action="clearfilter"]').show();
    }
    else {
    	$('[data-action="clearfilter"]').hide();
    }
    
    
        
   
    
    
    
    
    
    renderProducts(callback);
    

  }
  
  function renderProducts(callback) {
    
    //sort filtered products
    
    var _showProducts;
    if (_sortProducts.length==0) {
       _showProducts=filteredProducts.map((x) => x).slice(0, perpage*pageInx);;
    }
    else {
       _showProducts=filteredProducts.sort((a, b) =>_sortProducts.indexOf(a) > _sortProducts.indexOf(b) ? 1 : -1).slice(0, perpage*pageInx);
    }
    
 	$('[data-product]').filter((k,x)=>!_showProducts.includes(window.btoa('gid://shopify/Product/'+ x.dataset.product))).each(function() {    	 
      $(this).hide();
    });
    
    $('[data-product]').filter((k,x)=>_showProducts.includes(window.btoa('gid://shopify/Product/'+ x.dataset.product))).sort((a, b) =>_showProducts.indexOf(window.btoa('gid://shopify/Product/'+ a.dataset.product)) > _showProducts.indexOf(window.btoa('gid://shopify/Product/'+ b.dataset.product)) ? 1 : -1).appendTo('.wrap--full.wrap .row').each(function() {    	         
        $(this).attr('data-pos',_showProducts.indexOf(window.btoa('gid://shopify/Product/'+ this.dataset.product)));
    });
    const _classname=$('[data-product]').get(0).className;
    const _missedProducts=_showProducts.filter(x=>$(`[data-product="${window.atob(x).replace('gid://shopify/Product/','')}"]`).length==0);
    if (_missedProducts.length>0) loader(true);
    var _loadedMissed=0;
    if (_missedProducts.length>0) {
      $('[data-container="loadmore"]').css('opacity',0);
    }
    else {
     $('[data-product]').filter((k,x)=>_showProducts.includes(window.btoa('gid://shopify/Product/'+ x.dataset.product))).sort((a, b) =>_showProducts.indexOf(window.btoa('gid://shopify/Product/'+ a.dataset.product)) > _showProducts.indexOf(window.btoa('gid://shopify/Product/'+ b.dataset.product)) ? 1 : -1).appendTo('.wrap--full.wrap .row').each(function() {    	 
     	$(this).show();
     });
     if (filteredProducts.length>pageInx*perpage) {
      $('[data-container="loadmore"]').show();
      $('[data-container="loadmore-summary"]').text("You've viewed " + pageInx*perpage + " of " + filteredProducts.length + " products");
      $('[data-container="loadmore-percentage"] span').css('width',parseInt(100*pageInx*perpage/filteredProducts.length)+'%');
      $('[data-container="loadmore"]').css('opacity',1);
     }
     else {
      $('[data-container="loadmore"]').hide();
     }
    }
      _missedProducts.forEach(x=> {
         var _product=productsForFilter.filter(item => item.id === x)[0];
        if (_product!=undefined) {
        const  _id=window.atob(_product.id).replace('gid://shopify/Product/','');
        const _pos=_showProducts.indexOf(x)
        $.ajax({
        method    : 'GET',
        url       : document.location.origin+"/products/"+_product.handle+"/?view=card",        
        success: function (data) {
      


          if ($(`[data-product="${_id}"]`).length==0) {
           var el=$(data);
            el.get(0).className=_classname;
            el.attr('data-pos',_pos); 
            el.hide();
            $('.wrap--full.wrap .row').append(el);
            
            initSwatches();
            linkProductScroll();
            if (callback) callback.apply(_id+'');
          }
            _loadedMissed++;
            if (_loadedMissed>=_missedProducts.length) {
            loader(false);
            $('[data-product]').filter((k,x)=>_showProducts.includes(window.btoa('gid://shopify/Product/'+ x.dataset.product))).sort((a, b) =>_showProducts.indexOf(window.btoa('gid://shopify/Product/'+ a.dataset.product)) > _showProducts.indexOf(window.btoa('gid://shopify/Product/'+ b.dataset.product)) ? 1 : -1).appendTo('.wrap--full.wrap .row').each(function() {    	 
        		$(this).show();
      		});
            if (filteredProducts.length>pageInx*perpage) {
      			$('[data-container="loadmore"]').show();
      			$('[data-container="loadmore-summary"]').text("You've viewed " + pageInx*perpage + " of " + filteredProducts.length + " products");
      			$('[data-container="loadmore-percentage"] span').css('width',parseInt(100*pageInx*perpage/filteredProducts.length)+'%');      
                $('[data-container="loadmore"]').css('opacity',1);
		    }
            else {
               $('[data-container="loadmore"]').hide();
            }
            var __st;
            $.each(document.location.search.substring(1).split('&'), function () {       		
       			if (this.split('=')[0] == 'scrollto') __st = this.split('=')[1];                	
  			});
  
  	       if (__st != undefined) {
    	       $('html, body').scrollTop($('[data-product="' + __st + '"]').offset().top);
        	 }       	
          }
        }
      });
        }
      });
    
  }

function linkProductScroll() {
    $('[data-product]').off('click').on('click',function () {                
        if ((history && history.state != null) || $('[data-product]').length>perpage) {
            var obj = { Page: document.location.pathname, Url:"?page_m="+pageInx+"&scrollto=" + $(this).data('product') };
            history.replaceState(obj, obj.Page, obj.Url);
        }
    })
}
  
window.onpopstate = function(event) {
  
  var _page=1;
  $.each(document.location.search.substring(1).split('&'), function () {
       if (this.split('=')[0] == 'page_m') {
		 _page=parseInt(this.split('=')[1]);
       }
  });  
  if (_page!=pageInx) {
    pageInx=_page;
    showProducts();   
  }
}

$(document).ready(function(){
    productsForFilter=[];
  if (window.collectionHandle!=undefined && window.collectionHandle!="") {
    getAllData(buildUI);
    linkProductScroll();
    $('[data-action="clearfilter"]').click(function() {
      $('[data-filter-apply]').remove();
      $('.filter__item--active').removeClass('filter__item--active');
       appliedFilter=[];       
       lastFilter=0;
       pageInx=1;
       $.each(document.location.search.substring(1).split('&'), function () {
       if (this.split('=')[0] == 'page_m') {
       	const obj = { Page: document.location.pathname, Url:"?page_m=1" };            
       	history.pushState(obj, obj.Page, obj.Url);
       }
       });      
       showProducts(true);
    });
    $('[data-action="loadmore"]').click(function() {      
       pageInx=pageInx+1;       
       const obj = { Page: document.location.pathname, Url:"?page_m="+pageInx };            
       history.pushState(obj, obj.Page, obj.Url);
       showProducts();                         
    });
  }
  if ($('.filter-sort__item').length>0) {
    $('.filter-sort__item').click(function() {
      $('.filter-sort__item').not(this).removeClass('filter-sort__item--active');
      $(this).addClass('filter-sort__item--active');
      $('.filter-sort__title').text($(this).text());
      var _sort='TITLE';
      var isRevert=false;
      switch ($(this).attr('value')) {
        case 'best-selling':
          _sort='BEST_SELLING';
          break;
        case 'title-ascending':
          _sort='TITLE';
          break;
        case 'title-descending':
          _sort='TITLE';
          isRevert=true;
          break;
        case 'price-ascending':
          _sort='PRICE';
          break;
        case 'price-descending':
          _sort='PRICE';
          isRevert=true;
          break;
        case 'created-ascending':
          _sort='CREATED';          
          break;
        case 'created-descending':
          _sort='CREATED';
          isRevert=true;
          break;
        case 'manual':
          _sort='MANUAL';
          break;
        
      }
      getCollectionDataSort(_sort,isRevert);
    });
  }
  //if (collectionHandle=='all') {
  //  getAllData(buildUI);
  //}
  //else {
  //  getCollectionData(buildUI);
  //}
});